// extracted by mini-css-extract-plugin
export default {"tableHolder":"style_tableHolder__c79Df"};